import { useEffect, useState } from 'react';
import { INTERNAL_ACCOUNT_TYPE } from '../consts';

export const usePayments = ({
    isComboPayment,
    selectedPaymentSystems,
    setSelectedPaymentSystems,
    setIsActivePaymentSys,
    localization,
    setConvertedData
}) => {
    const [isActiveInternalAcc, setIsActiveInternalAcc] = useState(false);

    useEffect(() => {
        setIsActiveInternalAcc(() => {
            return selectedPaymentSystems.some((item) => item.keyType === INTERNAL_ACCOUNT_TYPE);
        });
    }, [selectedPaymentSystems]);

    useEffect(() => {
        setSelectedPaymentSystems([]);
        setIsActivePaymentSys(false);
        setIsActiveInternalAcc(false);
    }, [isComboPayment, setIsActivePaymentSys, setSelectedPaymentSystems]);

    useEffect(() => {
        setSelectedPaymentSystems((prev) => {
            // if (!isComboPayment) {
            //     setIsActivePaymentSys(false);
            //     setIsActiveInternalAcc(false);
            //     setConvertedData([]);
            //     return [];
            // }
            return prev.map((item) => ({ ...item, sumValue: '' }));
        });
    }, [localization.currency, setSelectedPaymentSystems, isComboPayment, setIsActivePaymentSys, setConvertedData]);

    return { isActiveInternalAcc };
};
